module.exports = __webpack_public_path__ + "img/investBg-m.080158f2.png";